/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const ListEventLogPayloadKinds = {
  Log: "log",
  Span: "span",
} as const;
export type ListEventLogPayloadKinds = ClosedEnum<
  typeof ListEventLogPayloadKinds
>;

/**
 * Payload for listing org-scoped OpenTelemetry events
 */
export type ListEventLogPayload = {
  /**
   * Opaque cursor for pagination
   */
  cursor?: string | undefined;
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Optional signal kind filter. Empty means both logs and spans.
   */
  kinds?: Array<ListEventLogPayloadKinds> | undefined;
  /**
   * Number of events to return (1-200)
   */
  limit?: number | undefined;
  /**
   * Optional event/span name filter. Values are ORed.
   */
  names?: Array<string> | undefined;
  /**
   * Optional case-insensitive substring match over event body and name
   */
  search?: string | undefined;
  /**
   * Optional source filter (canonicalized service names). Values are ORed.
   */
  sources?: Array<string> | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export const ListEventLogPayloadKinds$outboundSchema: z.ZodMiniEnum<
  typeof ListEventLogPayloadKinds
> = z.enum(ListEventLogPayloadKinds);

/** @internal */
export type ListEventLogPayload$Outbound = {
  cursor?: string | undefined;
  from: string;
  kinds?: Array<string> | undefined;
  limit: number;
  names?: Array<string> | undefined;
  search?: string | undefined;
  sources?: Array<string> | undefined;
  to: string;
};

/** @internal */
export const ListEventLogPayload$outboundSchema: z.ZodMiniType<
  ListEventLogPayload$Outbound,
  ListEventLogPayload
> = z.object({
  cursor: z.optional(z.string()),
  from: z.pipe(z.date(), z.transform(v => v.toISOString())),
  kinds: z.optional(z.array(ListEventLogPayloadKinds$outboundSchema)),
  limit: z._default(z.int(), 50),
  names: z.optional(z.array(z.string())),
  search: z.optional(z.string()),
  sources: z.optional(z.array(z.string())),
  to: z.pipe(z.date(), z.transform(v => v.toISOString())),
});

export function listEventLogPayloadToJSON(
  listEventLogPayload: ListEventLogPayload,
): string {
  return JSON.stringify(
    ListEventLogPayload$outboundSchema.parse(listEventLogPayload),
  );
}
